import { defineStore } from 'pinia'
import { useLocalStorage } from '@vueuse/core/index.cjs';
import ERP from "../ERP.mjs";
import Schema from "../Schema.mjs";

const colaborador = (params = {}) =>{
    return{
        id: params.id || "",
        codigo: params.code || "",
        nome: params.name || "",
        email: params.email || "",
    }
}

const useColaboradorStore = defineStore("ColaboradorStore",{
    state: () => ({
        colaborador: useLocalStorage("ColaboradorStore",colaborador())
    }),
    actions: {
        async save(colaboradorResponse) {

            this.colaborador = colaborador(colaboradorResponse);

        },
        clear() {
            this.colaborador = colaborador();
        },
    }
})

export default useColaboradorStore